import { getDatePickerValue } from '@lyearn/ui';
import { DateTagType } from '@/types/schema';

import { DateValue, UserTagValue } from '../../types';

export const getMultiSelectPlaceholder = (selectedLabels?: string[] | null) => {
  if (!selectedLabels?.length) {
    return undefined;
  }

  if (selectedLabels.length < 3) {
    return { text: selectedLabels.join(', ') };
  }

  return { text: selectedLabels.slice(0, 1).join(', ') + ', ', count: selectedLabels.length - 2 };
};

export const getUserTagTypePlaceholder = (tag: UserTagValue) => {
  if (!tag?.length) {
    return undefined;
  }

  let totalValues = 0;
  let opVals = [];
  for (let i = 0; i < tag.length; i++) {
    const currentTag = tag[i];
    totalValues++;
    opVals.push(currentTag.label);
    if (totalValues === 2) {
      break;
    }
  }

  if (tag.length < 3) {
    return { text: opVals.join(', ') };
  }

  return { text: opVals.join(', ') + ', ', count: tag.length - 2 };
};

export const getDateTagPlaceholder = (tag: DateTagType, tagValue: DateValue) => {
  return getDatePickerValue({
    startTime: tagValue?.startTime,
    endTime: tagValue?.endTime,
    includeTime: tag.includeTime,
    includeEndDate: tag.includeEndDate,
  });
};
